import { ReplyCommentState } from "app/components/ReplyComment/redux/types";

export const replyCommentSliceInitialState: ReplyCommentState = {
  mentionData: {},
};
